<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-05",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 57,
      nextPage: '/questionnaire/section4/6',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'labelBtn',
          mobile: 'labelBtn'
        },
        mainTitle: 'Have you ever been diagnosed with deficiency of any of the following nutrients within 6 months?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Iron',
              operation: 'add suggestion 14'
            },{
              text: 'Calcium',
              operation: 'add suggestion 15'
            },{
              text: 'Vitamins B',
              operation: 'add suggestion 16'
            }
          ],[
            {
              text: 'Vitamin D',
              operation: 'add suggestion 17'
            },{
              text: 'Vitamin C',
              operation: 'add suggestion 18'
            },{
              text: 'None of these',
              unique: true
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
